<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-item><b>Welcome to Cemetery Community Genealogy</b></v-card-item>
          <v-card-item>You can search the records of any cemetery in our community to find loved ones and information provided directly from cemetery records.</v-card-item>
        </v-card>
      </v-col>
    </v-row>
    
    <SearchComponent />

    <v-row>
      <v-col>
        <v-card>
          <v-card-item><b>View Our Cemetery Community Member Pages</b></v-card-item>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card-item>Would you like to become a member?  Contact us today!</v-card-item>
        <v-card-item>Call or text us at 810.328.3419 or email us at dan@danstechservices.us </v-card-item>
      </v-col>
    </v-row>

    <v-row v-for="cemetery in cemeteries" :key="cemetery.id">
      <v-col>
        <v-card link :href="'/cemetery/' + cemetery.genealogyslug">
          <v-card-item class="text-h6">{{ cemetery.name }}</v-card-item>
          <v-card-item>
            <v-card-text v-if="cemetery.address">
              {{ cemetery.address }}
            </v-card-text>
            <v-card-text v-if="cemetery.addresstwo">
              {{ cemetery.addresstwo }}
            </v-card-text>
            <v-card-text v-if="cemetery.addressthree">
              {{ cemetery.addressthree }}
            </v-card-text>
            <v-card-text v-if="cemetery.city && cemetery.state && cemetery.zipcode">
              {{ cemetery.city }}, {{ cemetery.state }} {{ cemetery.zipcode }}
            </v-card-text>
          </v-card-item>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import SearchComponent from '@/components/SearchComponent.vue';
import { defineComponent } from 'vue';

// Components

export default defineComponent({
  name: 'HomeView',

  components: {
    SearchComponent
  },

  data: () => ({
    cemeteries : [],
    loading : false
  }),

  created : function(){
    this.getCemeteries();
    this.pageView();
  },

  methods:{
    pageView(){
      fetch("https://app.cemeterycommunity.com:11000/api/pageview", { method: "POST", headers : { data : JSON.stringify( { cemeteryid : null, group : 'Genealogy', page : '/home' } ) } });
    },
    getCemeteries(){
      this.cemeteries = [];

      fetch("https://app.cemeterycommunity.com:11000/api/getgenealogycemeteries", { method: "POST" })
      .then( res => res.json() )
      .then( res =>  {
        if(res.results != "Failed" && res.results.length > 0) this.cemeteries = res.results;

        this.loading = false;
      });
    }
  }
});
</script>
